import { Box, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Hidden from "@material-ui/core/Hidden";
import history from "../../history";
import React from "react";
import Toolbar from "@material-ui/core/Toolbar";
import { BRButton } from "meu-inss-ds";
import './appFooter.css'
const drawerWidth = 310;

/**
 * AppFooter
 * 
 * @param {Object} props
 * @param {Function} [props.primaryAction] - A função da ação primária.
 * @param {string} [props.primaryText] - O texto do botão primário.
 * @param {Function} [props.primaryAction2] - A função da segunda ação primária.
 * @param {string} [props.primaryText2] - O texto do segundo botão primário.
 * @param {Function} [props.secondaryAction] - A função da ação secundária (padrão: `history.goBack`).
 * @param {string} [props.secondaryText] - O texto do botão secundário.
 * @param {Function} [props.tertiaryAction] - A função da ação terciária.
 * @param {string} [props.tertiaryText] - O texto do botão terciário.
 * @param {string} [props.tertiaryTextMobile] - O texto do botão terciário para mobile.
 * @param {boolean} [props.primaryDisabled] - Flag que desablita o botão primário.
 * @param {boolean} [props.primaryDisabled2] - Flag que desablita o segundo botão primário.
 * @param {boolean} [props.secondaryDisabled] - Flag que desablita o botão secundário.
 * @param {string} [props.primaryTextMobile] - O texto do botão primário para mobile.
 * @param {string} [props.primaryTextMobile2] - O texto do segundo botão primário para mobile.
 * @param {string} [props.secondaryTextMobile] - O texto do botão secundário para mobile.
 * @param {string} [props.textAlign] - O alinhamento horizontal do AppFooter para desktop.
 * @returns {JSX.Element}
 */
export default function AppFooter(props) {
  const classes = useStyles();
  let {
    primaryAction,
    primaryText,
    primaryAction2,
    primaryText2,
    secondaryAction = () => history.goBack(),
    secondaryText,
    tertiaryAction,
    tertiaryText,
    tertiaryTextMobile,
    primaryDisabled,
    primaryDisabled2,
    secondaryDisabled,
    primaryTextMobile,
    primaryTextMobile2,
    secondaryTextMobile,
    textAlign,
  } = props;

  const paddingRightReturn = () => {
    //se tiver botao primario, o paddingRight será 16px, caso contrário será 4px
    return (primaryText ? 2 : 0.5);
  }

  return (
    <React.Fragment>
      <Hidden mdUp implementation="css">
        <Box p={5} />
        <Box component="footer" position="fixed" className={classes.footer}>
          <Toolbar>
            <Grid
              container
              direction="row"
              style={{ padding: "8px 8px 0px 8px", marginBottom: "4px" }}
              spacing={1}
            >
              {tertiaryAction && tertiaryText && (
                <Grid item xs={12}>
                  <BRButton
                    className='block large'
                    onClick={tertiaryAction}
                  >
                    {tertiaryTextMobile || tertiaryText}
                  </BRButton>
                </Grid>
              )}

              {secondaryAction && secondaryText && (
                <Grid
                  item
                  xs={12}
                >
                  <BRButton
                    className='block large secondary'
                    disabled={secondaryDisabled}
                    onClick={secondaryAction}
                  >
                    {secondaryTextMobile || secondaryText}
                  </BRButton>
                </Grid>
              )}

              {primaryAction2 && primaryText2 && (
                <Grid item xs={12}>
                  <BRButton
                    className='block large primary'
                    onClick={primaryAction2}
                    disabled={primaryDisabled2}
                  >
                    {primaryTextMobile2 || primaryText2}
                  </BRButton>
                </Grid>
              )}

              <Grid
                item xs={12}
              >
                {primaryAction && primaryText && (
                  <BRButton
                    className='block large primary'
                    onClick={primaryAction}
                    disabled={primaryDisabled}
                  >
                    <span dangerouslySetInnerHTML={{__html: primaryTextMobile || primaryText}}></span>
                  </BRButton>
                )}
              </Grid>
            </Grid>
          </Toolbar>
        </Box>
      </Hidden>

      <Hidden smDown implementation="css">
        <Box component="footer" m={2} textAlign={textAlign} className={classes.footer_web}>
          {tertiaryAction && tertiaryText && (
              <Box paddingRight={2} component="span">
                {tertiaryAction && tertiaryText && (
                <BRButton
                    onClick={tertiaryAction}
                  className='large'
                  >
                    {tertiaryText}
                </BRButton>
                )}
              </Box>
          )}
          {secondaryAction && secondaryText && (
              <Box paddingRight={paddingRightReturn()} component="span">
                {secondaryAction && secondaryText && (
                <BRButton
                  onClick={secondaryAction}
                  className='large secondary'
                    disabled={secondaryDisabled}
                  >
                    {secondaryText}
                </BRButton>
                )}
              </Box>
          )}
          {primaryAction2 && primaryText2 && (
              <Box paddingRight={2} component="span">
              <BRButton
                className='large primary'
                  onClick={primaryAction2}
                  disabled={primaryDisabled2}
                >
                  {primaryText2}
              </BRButton>
              </Box>
          )}
          {primaryAction && primaryText && (
            <BRButton
              className='large primary'
              onClick={primaryAction}
              disabled={primaryDisabled}
            >
              <span dangerouslySetInnerHTML={{__html: primaryText}}></span>
            </BRButton>
          )}
        </Box>
      </Hidden>
    </React.Fragment>
  );
}

const useStyles = makeStyles((theme) => ({
  footer: {
    top: "auto",
    bottom: 0,
    left: 0,
    backgroundColor: theme.palette.background.default,
    shadows: ["none"],
    right: "0px",
    boxShadow:
      "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
  },
  footer_web: {
    margin: '0px',
    paddingTop: '48px'
  },
}));